import { render } from "./StatusIndicator.vue?vue&type=template&id=34992ef1&scoped=true"
import script from "./StatusIndicator.vue?vue&type=script&lang=js"
export * from "./StatusIndicator.vue?vue&type=script&lang=js"

import "./StatusIndicator.vue?vue&type=style&index=0&id=34992ef1&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-34992ef1"

export default script